module.exports = __webpack_public_path__ + "static/TiemposTextWeb-Regular-713a1eee9727ea36d73b56b4a2968d2f.eot";